module.exports = __webpack_public_path__ + "static/media/icon-retailer.18041800.svg";